import {
	Delete,
	Fetch,
	FetchJson,
	FetchList,
	IUseKeycloak,
	Post,
	PostJson,
} from "react-keycloak-manager";
import {
	IAlarm,
	ICalendar,
	IDayToCheck,
	IDaysToCheck,
	IGate,
	ISwitch,
	IZone,
} from "../interfaces/Entities";
import { PostList } from "react-keycloak-manager/dist/RestHelpers";

export async function getCalendars({
	createProtectedURL,
}: IUseKeycloak): Promise<ICalendar[] | null> {
	var result = await FetchList<ICalendar>(
		createProtectedURL("Calendar/GetCalendars"),
	);
	return result?.data ?? null;
}

export async function saveCalendar(
	{ createProtectedURL }: IUseKeycloak,
	calendar: ICalendar,
) {
	var result = await PostJson<ICalendar, number>(
		createProtectedURL("Calendar/SetCalendar"),
		calendar,
	);
	return result?.data ?? -1;
}

export async function deleteCalendar(
	{ createProtectedURL }: IUseKeycloak,
	calendar: ICalendar,
) {
	return await Delete<ICalendar>(
		createProtectedURL("Calendar/DeleteCalendar"),
		calendar,
	);
}

export async function loadCalendar(
	{ createProtectedURL }: IUseKeycloak,
	id: string,
): Promise<ICalendar | null> {
	var url = createProtectedURL("Calendar/GetCalendar");
	url.searchParams.set("id", id);

	var result = await FetchJson<ICalendar>(url);
	return result?.data ?? null;
}

export async function checkPeriod(
	{ createProtectedURL }: IUseKeycloak,
	listdaysToCheck: IDaysToCheck,
): Promise<IDayToCheck[] | null> {
	var result = await PostList<IDaysToCheck, IDayToCheck>(
		createProtectedURL("Calendar/DayIsEnable"),
		listdaysToCheck,
	);
	return result?.data ?? null;
}

export async function getAlarmsState({
	createProtectedURL,
}: IUseKeycloak): Promise<IAlarm[] | null> {
	var result = await PostList<any, IAlarm>(
		createProtectedURL("Alarms/GetAlarmsState"),
	);
	return result?.data ?? null;
}

export async function refreshAlarms({
	createProtectedURL,
}: IUseKeycloak): Promise<string | null> {
	var result = await PostJson<null, string>(
		createProtectedURL("Alarms/Refresh"),
		null,
	);
	return result?.data ?? null;
}

export async function getGatesEnabled({
	createProtectedURL,
}: IUseKeycloak): Promise<IGate[] | null> {
	var url = createProtectedURL("Gates/GetEnabled");
	url.searchParams.set("allDoors", String(false));
	var result = await FetchList<IGate>(url);
	return result?.data ?? null;
}

export async function getTestGatesEnabled(
	{ createProtectedURL }: IUseKeycloak,
	now: Date,
): Promise<IGate[] | null> {
	var url = createProtectedURL("Gates/GetEnabledTest");
	url.searchParams.set("allDoors", String(true));
	url.searchParams.set("now", now.toISOString());
	var result = await FetchList<IGate>(url);
	return result?.data ?? null;
}

export async function openDoor(
	{ createProtectedURL }: IUseKeycloak,
	door: IZone,
): Promise<string | null> {
	var result = await Post<IZone>(createProtectedURL("Gates/Open"), door);
	return result?.data ?? null;
}

export async function refreshGates({
	createProtectedURL,
}: IUseKeycloak): Promise<string | null> {
	var result = await Post<string>(createProtectedURL("Gates/Refresh"));
	return result?.data ?? null;
}

export async function getGates({
	createProtectedURL,
}: IUseKeycloak): Promise<IGate[] | null> {
	var result = await FetchList<IGate>(createProtectedURL("Gates/GetGates"));
	return result?.data ?? null;
}

export async function getServerTime({
	createProtectedURL,
}: IUseKeycloak): Promise<Date | null> {
	var result = await FetchJson<Date>(createProtectedURL("Debug/GetServerTime"));
	return result?.data ?? null;
}

export async function getUtcServerTime({
	createProtectedURL,
}: IUseKeycloak): Promise<Date | null> {
	var result = await FetchJson<Date>(
		createProtectedURL("Debug/getUtcServerTime"),
	);
	return result?.data ?? null;
}

export async function getEnvironmentVariable({
	createProtectedURL,
}: IUseKeycloak): Promise<string | null> {
	var result = await FetchJson<string>(
		createProtectedURL("Debug/EnvironmentGet"),
	);
	return result?.data ?? null;
}

export async function getWindows(
	{ createProtectedURL }: IUseKeycloak,
	onlyOpen: boolean,
): Promise<ISwitch[]> {
	var url = createProtectedURL("OpenHAB/GetSwitch");
	url.searchParams.set("onlyOpen", String(onlyOpen));
	var result = await FetchList<ISwitch>(url);
	return result?.data ?? [];
}

export async function getProtect({
	createProtectedURL,
}: IUseKeycloak): Promise<string | undefined> {
	var url = createProtectedURL("debug/ProtectedGet");
	var result = await Fetch<string>(url);
	return result?.ok
		? result.data
		: (result?.errors.concat().toString() ?? "undefined");
}

export async function getUnprotect({
	createURL,
}: IUseKeycloak): Promise<string | undefined> {
	var url = createURL("debug/UnprotectedGet");
	var result = await Fetch<string>(url);
	return result?.ok
		? result.data
		: (result?.errors.concat().toString() ?? "undefined");
}
